// extracted by mini-css-extract-plugin
export default {"buttonBlock":"buttonBlock__NzE0M","saveAndCancel":"saveAndCancel__N2NlM","deleteButton":"deleteButton__MDkzN"};